var React = require('react');

function Right (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.47 53.47A3.47 3.47 0 116.94 50a3.47 3.47 0 01-3.47 3.47zM26.24 46.53h60.47l-23-23 4.91-4.91L100 50 68.62 81.38l-4.91-4.91 23-23H26.24z"}));
}

Right.defaultProps = {"viewBox":"0 0 100 100"};

module.exports = Right;

Right.default = Right;
